import { render, staticRenderFns } from "./SharePrintCard.vue?vue&type=template&id=0007a6f6&scoped=true&"
import script from "./SharePrintCard.vue?vue&type=script&lang=js&"
export * from "./SharePrintCard.vue?vue&type=script&lang=js&"
import style0 from "./SharePrintCard.vue?vue&type=style&index=0&id=0007a6f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0007a6f6",
  null
  
)

export default component.exports